import axios from 'axios'

import type { Creator } from '@/modules/creators/types'

import { apiClient } from '../axios'
import type { ExportOptions } from './types'

export const exportDataFromServer = async (
  creatorID: Creator['id'],
  options: ExportOptions,
  signal?: AbortSignal,
): Promise<void> => {
  try {
    const { url } = (
      await apiClient.post(`/dataexport/export/${creatorID}`, options, {
        signal,
      })
    ).data

    const link = document.createElement('a')

    link.href = url
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log('Request was canceled', error.message)

      return
    }
    console.error('Failed to export data from server:', error)
    throw error
  }
}
